<template>
  <div id="app">
    <audio :src="require('../public/media/click.mp3')" ref="click" controls preload="auto"></audio>

    <audio
      :src="require('../public/media/bgm.mp3')"
      ref="bgm"
      id="bgm"
      controls
      preload="auto"
      loop
    ></audio>

    <!-- 落版页 -->
    <Landing
      ref="landing"
      :userInfo="userInfo"
      :userArticle="userArticle"
      :number="number"
      :short="short"
      :showLanding="showLanding"
      :paper="paper"
      :showLandingTop="showLandingTop"
      @back="landingBack"
      @click="playMusicClick"
      @join="join"
      @loaded="imgLoaded"
    />

    <div class="bg center" :class="{'short': short, 'noBg': showLanding}">
      <!-- <img class="logo middle-center" src="./assets/imgs/logo.png" /> -->
      <!-- 编辑文章 -->
      <!-- <Edit
        v-show="showEdit"
        :paper="paper"
        :userInfo="userInfo"
        @back="editBack"
        @submit="editSubmit"
        @click="playMusicClick"
        @join="join"
      />-->

      <!-- 填写信息 -->
      <div class="infoBox">
        <div
          class="infoContainer"
          v-show="showInfo"
          :class="{'showInfo': showInfo, 'infoLeave': showInfoLeave }"
        >
          <Info :number="number" @open="getData" @submit="submitInfo" />
        </div>
      </div>

      <transition name="fade1">
        <!-- autoplay -->
        <video
          class="video center"
          ref="video"
          preload="auto"
          muted="muted"
          src="../public/media/video.mp4"
          poster="../public/media/poster.jpg"
          playsinline="true"
          webkit-playsinline="true"
          x-webkit-airplay="allow"
          airplay="allow"
          x5-video-player-type="h5"
          x5-video-player-fullscreen="true"
          x5-video-orientation="portrait"
          @ended="videoEnd"
          v-show="showVideo"
          @click="videoPlay"
        ></video>
      </transition>

      <!-- 播放 -->
      <transition name="fade">
        <div class="play center" v-show="videoPlayShow" @click="videoPlay">
          <img src="./assets/imgs/play.png" alt />
        </div>
      </transition>

      <!-- Loading页 -->
      <Loading
        v-if="showLoading"
        :showLoading="showLoading"
        :short="short"
        @loadingShow="loadingShow"
      />
    </div>

    <img class="loading_logo" src="../public/imgs/loading_logo.png" v-if="showLoading" />

    <div class="popover center" v-show="showPopover">
      <div class="popoverContent center">正在生成中...</div>
    </div>

    <!-- 跳过 -->
    <transition name="fade">
      <div class="skip" v-show="showVideo" @click="videoEnd">
        <img src="./assets/imgs/skip.png" alt />
      </div>
    </transition>

    <!-- 音乐 -->
    <div
      class="updown-center"
      v-if="!showLoading"
      :class="[showLanding?'music_right':'music_left',showVideo?'video_music':'']"
      @click="handleMusic"
    >
      <img :src="require(`./assets/imgs/music_${musicOn?'on':'off'}.png`)" />
    </div>

    <Screen />
  </div>
</template>

<script>
import Screen from "./components/screen";
import Info from "./components/Info";
// import Edit from "./components/Edit";
import Landing from "./components/Landing";
import Loading from "./components/Loading";
// import axios from 'axios';
import { baseRequestUrl, encrypt, request } from "./assets/js/baseConfig";
import wechatShare from "./assets/js/share";
import AsyncPreloader from "async-preloader";
import { RndNum } from "./assets/js/utils";

let timeout;

export default {
  name: "App",

  data() {
    return {
      showLoading: true,
      showVideo: false,
      showInfo: false,
      // showEdit: false,
      showLanding: false,
      paper: {
        // 后台获取的考卷信息
        content: "",
        title: ""
      },
      userInfo: {
        // 用户填写的信息
        name: "zly",
        year: 2006,
        province: "江苏省"
      },
      number: "0", // 试卷编号
      userArticle: {
        // 用户的考卷数据
        title: "新时代新青年新时新时新青年新时新时",
        article: "那年最难那"
      },
      platform: "weixin",
      musicOn: true,
      showInfoLeave: false,
      videoPlayShow: false,
      short: window.innerWidth / window.innerHeight > 0.56,
      showPopover: false,
      showLandingTop: false
    };
  },
  components: {
    Screen,
    Loading,
    Info,
    // Edit,
    Landing
  },

  methods: {
    videoEnd() {
      this.showVideo = false;
      console.log("end");
      if (!this.showEdit && !this.showLanding) this.showInfo = true;
      this.videoPlayShow = false;
    },
    loadingShow() {
      this.showVideo = true;
      this.showLoading = false;
      this.$refs.video.play();
      console.log("play video");
      setTimeout(() => {
        this.showInfo = true;
      }, 1000);
    },

    getData(data) {
      this.userInfo = data;

      request("paper/", {
        province: data.province,
        year: data.year
      }).then(res => {
        if (res.data) {
          this.paper = res.data;

          this.$nextTick(() => {
            this.$children[0].getImg();
          });
        } else {
          if (res.data.error_code) {
            alert(res.data.error_message);
          }
        }
      });
    },

    submitInfo(data) {
      this.showInfoLeave = true;

      timeout = setTimeout(() => {
        this.showInfo = false;
        this.showInfoLeave = false;

        this.showLandingTop = true;
      }, 1500);

      this.showLanding = true;
      // this.showEdit = true;
    },

    // editBack() {
    //   this.showInfo = true;

    //   this.showEdit = false;

    //   clearTimeout(timeout);
    //   this.showInfoLeave = false;
    // },

    // editSubmit(data) {
    //   this.userArticle = data;

    //   this.showPopover = true

    //   this.$children[0].getImg()

    //   this.showPopover = true
    //   this.showLanding = true;
    // },

    imgLoaded() {
      this.showEdit = false;

      // this.showLandingTop = true

      this.showPopover = false;
    },

    landingBack() {
      clearTimeout(timeout);
      this.showLanding = false;

      this.showInfo = true;

      this.showInfoLeave = false;

      this.showLandingTop = false;
    },

    /**
     * 判断用户打开网页的平台
     */
    getPlatForm() {
      let ua = navigator.userAgent.toLowerCase();

      if (ua.indexOf("weibo") != -1) {
        this.platform = "weibo";
        this.videoPlayShow = true;
      } else if (ua.indexOf("newsarticle") != -1) {
        this.platform = "toutiao";
        // console.log("toutiao");
        // if (this.$refs.video.paused) this.$refs.video.play()
      }

      // console.log(ua)
      if (ua.indexOf("android") != -1) {
        console.log("android");
        this.videoPlayShow = true;
      }
    },

    /**
     * 点击音效
     */
    playMusicClick() {
      this.$refs.click.play();
    },

    handleMusic() {
      const music = this.$refs.bgm;

      console.log("music.paused", music.paused);

      if (music.paused) {
        music.play();

        this.musicOn = true;
      } else {
        music.pause();

        this.musicOn = false;
      }
    },

    videoPlay() {
      console.log("play");
      this.$refs.video.play();
      this.videoPlayShow = false;
    },

    join() {
      switch (this.platform) {
        case "toutiao":
          MtaH5.clickStat("tt_redirect");
          window.location.href = "https://xxz.toutiao.com/?from=hhdn";
          break;
        case "weibo":
          MtaH5.clickStat("wb_redirect");
          window.location.href = "https://xxz.toutiao.com/?from=hhwb";
          break;
        default:
          MtaH5.clickStat("wx_redirect");
          window.location.href = "https://xxz.toutiao.com/?from=hhwx";
          break;
      }
    }
  },

  mounted() {
    // request("paper/stat/").then(res => {
    //   this.number = res.data.pv;
    // });

    this.number = RndNum(5);
    console.log(navigator.userAgent);
    wechatShare();
    console.log(window.innerWidth, window.innerHeight);
    this.getPlatForm();

    // this.handleMusic()
    this.$nextTick(() => {
      const music = this.$refs.bgm;
      if (music.paused) {
        music.play();
        this.musicOn = true;
      }
      let UserAgent = navigator.userAgent.toLowerCase();

      // if (/android|newsarticle/.test(UserAgent)) {
      //   this.$refs.video.addEventListener("timeupdate", () => {
      //     if (this.$refs.video.currentTime) {
      //       this.videoPlayShow = false;
      //     } else {
      //       this.videoPlayShow = true
      //     }
      //   });
      // }

      if (/android/.test(UserAgent) || /newsarticle/.test(UserAgent)) {
        this.$refs.video.addEventListener("timeupdate", () => {
          console.log(this.$refs.video.currentTime);

          if (this.$refs.video.currentTime > 0.1) {
            this.videoPlayShow = false;
          }
        });
      }

      // $webfont.load(".landing", "67ecec10abaa4c79864293ff83c34409", "SourceHanSerif-H");
    });
  }
};
</script>

<style lang="less">
body,
html {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: fixed;
  overflow: hidden;
  touch-action: manipulation;
}
// @font-face {
//   font-family: SourceHanSerif;
//   src: url("../public/font/SourceHanSerifCN-Regular.otf");
// }
@font-face {
  font-family: SourceHanSerifBold;
  src: url("../public/font/SourceHanSerifCN-Bold.ttf");
}
// @font-face {font-family: 'SourceHanSerif-21bf1ec28a17531';src: url('"../public/font/5f008060f629d808a4140fc5.gif?r=142261985187');src: url('"../public/font/5f008060f629d808a4140fc5.gif?r=142261985187?#iefix') format('embedded-opentype'),url('"../public/font/5f008060f629d808a4140fc5.png?r=142261985187') format('woff2'),url('"../public/font/5f008060f629d808a4140fc5.bmp?r=142261985187') format('woff'),url('"../public/font/5f008060f629d808a4140fc5.jpg?r=142261985187') format('truetype');font-weight: normal;font-style: normal;}
// .css21bf1ec28a17531{font-family: 'SourceHanSerif-21bf1ec28a17531';}

#app {
  font-family: SourceHanSerif, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #876648;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  display: flex;
  align-content: center;
}
.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.middle-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.updown-center {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade1-leave-active {
  transition: opacity 0.5s;
}
.fade1-leave-to {
  opacity: 0;
}

.bg {
  width: 750px;
  height: 1624px;
  background: url(../public/imgs/bg1.jpg);
  background-size: cover;
  // margin-top: -60px;
  &.noBg {
    background-image: none;
  }

  &.short {
    margin-top: -60px;
    // .logo {
    //   bottom: 208px;
    // }
  }
}

.logo {
  position: absolute;
  bottom: 208px;
  mix-blend-mode: multiply;
}

.video {
  width: 750px;
  // height: 1464px;
  // width: 100%;
  // height: 100%;
  // min-height: 1624px;
}

@keyframes leaveFromTop {
  to {
    transform: translateY(1400px);
  }
}

.loading_logo {
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  margin: auto;
}

.infoContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  animation: none;
  opacity: 0;
  &.showInfo {
    opacity: 1;
  }
  &.infoLeave {
    animation: leaveFromTop 2s forwards;
  }
}

div,
img {
  -webkit-tap-highlight-color: rgba(255, 0, 0, 0);
  user-select: none;
}

img:not(.hasPointEvent) {
  pointer-events: none;
}

audio {
  opacity: 0;
  position: absolute;
}

.music_left {
  margin-top: -460px;
  left: 20px;
  z-index: 5;
}
.music_right {
  margin-top: -527px;
  right: 20px;
  z-index: 5;
}
.video_music {
  transform: none;
  margin-top: auto;
  top: 40px;
  right: 20px;
  left: auto;
  z-index: 5;
}
.skip {
  position: absolute;
  left: 20px;
  top: 40px;
}
.popover {
  width: 100%;
  height: 100%;
  font-size: 30px;
  .popoverContent {
    color: #000;
    font-family: "黑体";
    margin-top: 60px;
  }
}
.short {
  .popoverContent {
    margin-top: 0;
  }
}
</style>
